const insertExitBlock = require('./insertExitBlock')

function insertBlockIfNecessary (block, event, data, state) {
  // - up and down arrow navigates unless only element in editor
  // - if adjacent nodes and block selected left / right creates text before / after
  // - if adjacent nodes and block selected any key other than backspace starts writing

  const hasContentBefore = state.document.getPreviousSibling(block.key)
  const hasContentAfter = state.document.getNextSibling(block.key)
  const hasBlockAfter = hasContentAfter && hasContentAfter.kind === 'block'
  const hasBlockBefore = hasContentBefore && hasContentBefore.kind === 'block'
  let transform
  if (data.key === 'up') {
    if (!hasContentBefore) {
      transform = insertExitBlock({state, transform: state.transform(), block})
    }
  } else if (data.key === 'down') {
    if (!hasContentAfter) {
      transform = insertExitBlock({state, transform: state.transform(), block, after: true})
    }
  } else if (data.key === 'right') {
    if (hasBlockAfter) {
      transform = insertExitBlock({state, transform: state.transform(), block, after: true})
    }
  } else if (data.key === 'left') {
    if (hasBlockBefore) {
      transform = insertExitBlock({state, transform: state.transform(), block})
    }
  } else if (data.key === 'right') {
    if (hasBlockAfter) {
      transform = insertExitBlock({state, transform: state.transform(), block, after: true})
    }
  } else if (data.key === 'enter' || (event.keyCode > 48 && event.keyCode < 91)) {
    // any other char
    transform = insertExitBlock({state, transform: state.transform(), block, after: true})
  }

  if (transform) {
    return transform
  }
}

module.exports = insertBlockIfNecessary



// WEBPACK FOOTER //
// ./src/slateUtils/insertExitBlockIfNecessary.js